import axios from 'axios';
import intersection from 'lodash/intersection';

import { formatHomes } from './index';

export default (boundaries = {}) => {
  if (
    intersection(Object.keys(boundaries), [
      'latMin',
      'latMax',
      'lngMin',
      'lngMax'
    ]).length !== 4
  ) {
    // if boundaries are missing reject
    return Promise.reject(Error('Boundaries are not valid.'));
  }
  return axios({
    url: 'https://oss.canalplustelecom.com/interop-rest/immeublelist',
    method: 'GET',
    params: boundaries
  })
    .then(response => response.data)
    .then(formatHomes);
};
